import { Actor, ActorConfig, ActorSubclass } from '@icp-sdk/core/agent'
import { IDL } from '@icp-sdk/core/candid'

// Use this helper function to initialize Actor with pollingOptions.strategy = defaultStrategy
// although it is "default", calls seem to timeout incorrectly without it
export function createActor<ActorType>(factory: IDL.InterfaceFactory, options: ActorConfig) {
  return Actor.createActor(factory, {
    ...options,
  }) as ActorSubclass<ActorType>
}
